import { FooterNavKey } from "../../../common/mobileFooter";

export type FooterNavMeta = {
  label: string;
  icon: string;
  iconClass: string;
  path?: string;
  match?: string[];
  casino?: boolean;
};

export const FOOTER_NAV_META: Record<FooterNavKey, FooterNavMeta> = {
  games: {
    label: "Games",
    icon: "/images/promot.svg",
    iconClass: "icon-promote",
    casino: true,
  },
  sports: {
    label: "Sports",
    icon: "/images/Sports.svg",
    iconClass: "icon-sports",
    path: "/cricket",
    match: ["/cricket", "/soccer", "/tennis", "/Esoccer", "/basketBall"],
  },
  inplay: {
    label: "In-Play",
    icon: "/images/menu-In-Plan.svg",
    iconClass: "icon-inplay",
    path: "/in-play",
    match: ["/in-play"],
  },
  home: {
    label: "Home",
    icon: "/images/Home.svg",
    iconClass: "icon-home",
    path: "/",
    match: ["/", "/#"],
  },
  multi: {
    label: "Multi Markets",
    icon: "/images/Multi-Markets.svg",
    iconClass: "icon-pin",
    path: "/multimarket",
    match: ["/multimarket"],
  },
  account: {
    label: "Account",
    icon: "/images/Account.svg",
    iconClass: "icon-account",
    path: "/myAccount",
    match: ["/myAccount", "/user"],
  },
};

export const isFooterItemActive = (key: FooterNavKey, pathname: string) => {
  const segment = pathname.split("/").filter(Boolean)[0]?.toLowerCase() || "";
  if (key === "home") {
    return pathname === "/" || pathname === "/#";
  }
  if (key === "multi") {
    return segment === "multimarket";
  }
  const meta = FOOTER_NAV_META[key];
  const matches = meta.match || (meta.path ? [meta.path] : []);
  return matches.some(
    (item) => pathname === item || pathname.startsWith(`${item}/`),
  );
};
